<template>
    <div class="carousel">
        <div class="carousel__intro_mobile md:hidden max-w-[380px] mb-[50px]">
            <h2 v-if="showTitleBoolean" class="font-normal text-left mb-[10px]">{{ title }} {{ showTitleBoolean }}</h2>
            <p v-if="introduction" class="text-left">{{ introduction }}</p>
            <p v-if="link" class="text-left">
                <a :href="link" :class="linkStyle" class="text-left">{{ linkTitle }}</a>
            </p>
        </div>

        <div class="carousel-grid" :class="transitionClass"
             @touchstart="handleTouchStart"
             @touchmove="handleTouchMove"
             @touchend="handleTouchEnd"
             :style="touchStyle"
        >
            <div class="carousel__intro mr-[30px] z-[2] bg-scheme flex-col justify-center items-start hidden md:flex">
                <h2 class="font-normal text-left mb-[10px]">{{ title }}</h2>
                <p class="text-left">{{ introduction }}</p>
                <p class="text-left">
                    <a :href="link" :class="linkStyle" class="text-center">{{ linkTitle }}</a>
                </p>
            </div>
            <div class="carousel-item-holder z-[1] w-full h-full" v-for="(item, index) in allItems">
                <a v-if="item.LinkURL" :href="item.LinkURL" :target="newWindow(item)" :class="imageRounding"
                     class="carousel-item cursor-pointer no-underline p-p40 w-full h-full bg-cover bg-center overflow-hidden flex flex-center-all banner-overlay banner-overlay-dark after:z-[1]"
                     :style="{
                        backgroundImage: 'url(' + item.ImageURL + ')',
                        backgroundPositionY: item.FocusPointY + '%',
                        backgroundPositionX: item.FocusPointX + '%' }">
                    <h3 class="text-white no-underline font-normal z-[2]">{{ item.Title }}</h3>
                </a>
                <span v-else :class="imageRounding"
                     class="carousel-item no-underline w-full h-full p-p40 bg-cover bg-center  overflow-hidden flex flex-center-all banner-overlay banner-overlay-dark after:z-[1]"
                     :style="{
                        backgroundImage: 'url(' + item.ImageURL + ')',
                        backgroundPositionY: item.FocusPointY + '%',
                        backgroundPositionX: item.FocusPointX + '%' }">
                    <h3 class="text-white no-underline font-normal z-[2]">{{ item.Title }}</h3>
                </span>
            </div>
        </div>
        <div class="pointer-events-none md:absolute md:w-[calc(100%_-_360px)] controls md:top-[210px] md:left-[360px] mt-[30px] md:mt-[0px] z-[3]">
            <div class="pointer-events-none flex justify-center md:justify-between align-center items-center gap-p20">
                <button class="pointer-events-auto p-0 btn-main w-[60px] md:w-[80px] h-[60px] md:h-[80px] flex flex-center-all" :class="imageRounding" v-on:click.prevent="shiftRight">
                    <svg class="carousel__icon" xmlns="http://www.w3.org/2000/svg" width="80"
                         height="80" viewBox="0 0 80 80">
                        <g data-name="Group 524" transform="rotate(180 607.124 2216.624)">
                            <rect data-name="Rectangle 23" width="80" height="80" rx="40"
                                  transform="translate(1134.248 4353.248)" style="fill: none"/>
                            <g data-name="Group 47">
                                <path data-name="Line 58" transform="rotate(-90 2774.319 1619.259)"
                                      style="stroke-linejoin:round;fill:none;stroke-width:2px"
                                      d="M0 0v37.709"/>
                                <path data-name="Path 36" d="m0 0 9.252 9.252L18.5 0"
                                      transform="rotate(-90 2793.27 1609.56)"
                                      style="fill:none;stroke-width:2px"/>
                            </g>
                        </g>
                    </svg><span class="sr-only">Shift Right</span>
                </button>
                <button class="pointer-events-auto p-0 btn-main w-[60px] md:w-[80px] h-[60px] md:h-[80px] flex flex-center-all"
                        :class="imageRounding"
                        v-on:click.prevent="shiftLeft">
                    <svg class="carousel__icon" xmlns="http://www.w3.org/2000/svg" width="80" height="80"
                         viewBox="0 0 80 80">
                        <g data-name="Group 523" transform="translate(-1134.306 -4353.248)">
                            <rect data-name="Rectangle 23" width="80" height="80" rx="40"
                                  transform="translate(1134.306 4353.248)" style="fill: none"/>
                            <g data-name="Group 47">
                                <path data-name="Line 58" transform="rotate(-90 2774.341 1619.266)"
                                      style="stroke-linejoin:round;fill:none;stroke-width:2px"
                                      d="M0 0v37.736"/>
                                <path data-name="Path 36" d="m0 0 9.258 9.258L18.517 0"
                                      transform="rotate(-90 2793.306 1609.56)"
                                      style="fill:none;stroke-width:2px"/>
                            </g>
                        </g>
                    </svg><span class="sr-only">Shift Left</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FeaturesCarousel",
    data() {
        return {
            allItems: [],
            shift: 0,
            isTransitioning: false,
            transitionClass: '',
            touchStartX: 0,
            touchEndX: 0,
            minSwipeDistance: 50, // Minimum distance to recognize a swipe
            isTouching: false,
            touchStyle: {}
        };
    },
    props: {
        items: {
            type: String,
            default: []
        },
        title: {
            type: String,
            default: ""
        },
        showTitle: {
            type: String
        },
        introduction: {
            type: String,
            default: ""
        },
        link: {
            type: String,
            default: ""
        },
        linkTitle: {
            type: String,
        },
        linkStyle: {
            type: String,
            default: ""
        },
        imageRounding: {
            type: String,
        }
    },
    computed: {
        showTitleBoolean: function () {
            if (!this.showTitle || this.showTitle == "No") {
                return false;
            }
            return true;
        }
    },
    mounted() {
        this.allItems = JSON.parse(this.items);
        this.allItems = JSON.parse(this.items).map(item => {
            return {
                ...item,
                opacity: 1  // Initialize all items with opacity 1
            };
        });
        const carouselGrid = this.$el.querySelector('.carousel-grid');
        carouselGrid.addEventListener('touchmove', this.handleTouchMove, {passive: false});

    },
    beforeUnmount() {
        const carouselGrid = this.$el.querySelector('.carousel-grid');
        carouselGrid.removeEventListener('touchmove', this.handleTouchMove);
    },
    methods: {
        shiftLeft: function () {
            // Add the transition class
            this.isTransitioning = true;
            this.transitionClass = 'transition-left';
            this.touchStyle = {}; // Clear any inline styles


            // Wait for transition animation to start
            setTimeout(() => {
                // Perform your existing array shift operation here
                // For example: this.items.shift();
                const firstItem = this.allItems.shift();
                this.allItems.push(firstItem);

                // After the shift operation, remove the class
                setTimeout(() => {
                    this.isTransitioning = false;
                    this.transitionClass = '';
                }, 50); // Small delay to ensure DOM updates
            }, 100); // Adjust this timeout to match your desired transition duration

        },
        shiftRight: function () {
            // Add the transition class
            this.isTransitioning = true;
            this.transitionClass = 'transition-right';
            this.touchStyle = {}; // Clear any inline styles


            // Wait for transition animation to start
            setTimeout(() => {
                // Perform your existing array pop/shift operation here
                // For example: this.items.pop();
                const lastItem = this.allItems.pop(); // Remove the last item
                this.allItems.unshift(lastItem); // Add it to the beginning of the array

                // After the pop operation, remove the class
                setTimeout(() => {
                    this.isTransitioning = false;
                    this.transitionClass = '';
                }, 50); // Small delay to ensure DOM updates
            }, 100); // Adjust this timeout to match your desired transition duration
        },
        colStart: function (index) {
            let totalItems = this.allItems.length;
            let endColumn = (index + 1 + this.shift) % totalItems + 1;
            return endColumn + 1;
        },
        newWindow: function (item) {
            if (item.OpenInNewWindow === 'true') {
                return "_blank";
            }
            return "_self";
        },
        handleTouchStart(e) {
            // Don't initiate a new touch if we're in transition
            if (this.isTransitioning) return;

            this.touchStartX = e.changedTouches[0].screenX;
            this.isTouching = true;
            this.touchDeltaX = 0;

            // Reset any transition classes to ensure clean state
            this.transitionClass = '';

        },
        handleTouchMove(e) {
            if (!this.isTouching || this.isTransitioning) return;

            // Calculate how far the user has dragged
            this.touchEndX = e.changedTouches[0].screenX;
            this.touchDeltaX = this.touchEndX - this.touchStartX;

            // Apply a resistance factor to make dragging feel more natural
            // The further you drag, the more resistance you feel
            const resistanceFactor = 0.5;
            const transformX = this.touchDeltaX * resistanceFactor;

            // Apply the transform to follow the finger
            this.touchStyle = {
                transform: `translateX(${transformX}px)`,
                transition: 'none' // Ensure no transition during drag
            };

            // Prevent scrolling if a significant horizontal movement is detected
            if (Math.abs(this.touchDeltaX) > 10 &&
                Math.abs(this.touchDeltaX) > Math.abs(e.changedTouches[0].screenY - e.targetTouches[0].screenY)) {
                e.preventDefault();
            }

        },
        handleTouchEnd(e) {
            if (!this.isTouching || this.isTransitioning) return;
            this.isTouching = false;

            // Calculate final position
            this.touchEndX = e.changedTouches[0].screenX;
            this.touchDeltaX = this.touchEndX - this.touchStartX;

            // Reset the inline transform style
            this.touchStyle = {
                transform: 'translateX(0)',
                transition: 'transform 0.3s ease' // Smooth transition back if not triggering a slide
            };

            // Check if swipe distance meets the minimum threshold
            if (Math.abs(this.touchDeltaX) >= this.minSwipeDistance) {
                if (this.touchDeltaX > 0) {
                    // Swipe right, show previous items
                    this.shiftRight();
                } else {
                    // Swipe left, show next items
                    this.shiftLeft();
                }
            }

            // Reset values
            setTimeout(() => {
                this.touchStyle = {};
            }, 300); // Clear style after transition

        }

    },
    beforeDestroy() {
        clearInterval(this.carouselInterval);
    }
}
</script>


<style scoped>

.carousel-grid {
    transition: transform 0.3s ease;
    will-change: transform; /* Optimization for animations */
    touch-action: pan-y; /* Allow vertical scrolling but optimize for horizontal interactions */
}


.carousel-item {
    transition: opacity 300ms ease;
}

.transition-left .carousel-item-holder {
    animation: slideLeft 100ms ease-in-out;
}

.transition-right .carousel-item-holder {
    animation: slideRight 100ms ease-in-out;
}

@keyframes slideLeft {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}

@keyframes slideRight {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(100%);
    }
}

</style>
